module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_waso_yoso@3x-5321412f6949c32edb375ca2d8326869.webp";